import styled from 'styled-components'

export const FormTextAreaInput = styled.textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme }) => theme.colors.primary};

  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};

  ${({ resize }) => !resize && 'resize: none;'}

  &::placeholder {
    color: ${({ theme }) => theme.colors.primary};
  }
`
